/* eslint-disable react/prop-types */
import { sanitize } from '@/utils/misc';

function DefaultPageContent({pageData}) {
  return (
    <div className="container mx-auto py-36 min-h-screen">
      <div className="min-h-screen page-content">
          <h1 dangerouslySetInnerHTML={{ __html: sanitize(pageData?.title?.rendered ?? '') }} />
          <div dangerouslySetInnerHTML={{ __html: sanitize(pageData?.content?.rendered ?? '') }} />
      </div>
    </div>
  )
}

export default DefaultPageContent